import ContentLoader from "../contentLoader/contentLoader";

const SkeletonLoaderWrapper = (props) => {
	const { loading } = props
	return !loading ? (
		<>{props.children}</>
	) : (
		<ContentLoader loading={loading}/>
	)
};

export default SkeletonLoaderWrapper